// Convert kebab-case to camelCase: my-page-asset > myPageAsset
export const camelize = s => s.replace(/-(.)/g, l => l[1].toUpperCase());

// Capitalize first letter of the string: my-page-asset > My-page-asset
export const capitalize = s => s?.charAt(0).toUpperCase() + s?.slice(1);
